import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';
import { SubscriptionInfo } from 'shared/providers/subscription-info/domain/models/subscription-info';

const baseUrlV1 = '/api/v1/Subscription';
const baseUrlV6 = '/api/v6/Subscription';

const getSubscriptionInfo = async (axiosInstance: AxiosInstance): Promise<SubscriptionInfo> => {
  try {
    const response = await axiosInstance.get(`${baseUrlV6}/GetSubscriptionInfo?subscriptionDeviceType=Portal`);
    return response.data as SubscriptionInfo;
  } catch (error) {
    throw new Error('Error while calling GetSubscriptionInfo', {
      cause: error,
    });
  }
};

const deleteSubscriptionInfo = async (axiosInstance: AxiosInstance) => {
  try {
    const response = await axiosInstance.delete(`${baseUrlV1}/DeleteSubscriptionInfo?SubscriptionDeviceType=Portal&ListenerDeviceType=All`);
    return response.data;
  } catch (error) {
    throw new Error('Could not delete subscription info', { cause: error });
  }
};

export const useLazyGetSubscriptionInfoQuery = (): UseQueryResult<SubscriptionInfo> => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: ['GetSubscriptionInfo'],
    queryFn: () => getSubscriptionInfo(authenticatedInstance),
    refetchOnWindowFocus: true,
    enabled: false,
  });
};

export const useDeleteSubscriptionInfoMutation = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: ['DeleteSubscriptionInfo'],
    mutationFn: () => deleteSubscriptionInfo(authenticatedInstance),
  });
};
